export default {
  SET_CATEGORY_LIST(state, payload) {
    state.category = payload;
  },
  ADD_CATEGORY_LIST(state, payload) {
    state.category.push(payload);
  },
  EDIT_CATEGORY_LIST(state, payload) {
    const muIndex = state.category.findIndex(u => u.id === payload.id);
    state.category.splice(muIndex, 1, payload);
  },
  DELETE_CATEGORY_LIST(state, payload) {
    const muIndex = state.category.findIndex(u => u.id === payload.id);
    state.category.splice(muIndex, 1);
  }
};
